import { InputText } from "primereact/inputtext"
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import * as Fa from "react-icons/fa"
import { RadioButton, RadioButtonChangeEvent } from 'primereact/radiobutton'
import { InputSwitch } from 'primereact/inputswitch'
import { Calendar } from "primereact/calendar"
import { Dropdown } from "primereact/dropdown"
import { useEffect, useRef, useState } from "react"
import thumbnailUpload from '../../Assets/Images/thumbnail_upload.png';
import { format, subDays } from "date-fns"
import { fetchData, postData } from "../../Services/GlobalService"
import { MultiSelect } from "primereact/multiselect"
import { downloadExcelDateFormat } from "../../Services/GlobalFunction/DownLoadExcel"
import { GetDateFormat } from "../../Services/GlobalFunction/GetDateFormat"
import { toast } from "react-toastify"
import * as XLSX from "xlsx";
import Loader from "../../Components/Loader"
import { AxiosExcel } from "../../API/Axios"

const BannerUploadCSDView = () => {

    const ControllerImage = "FileUpload";
    const Controller = "BannerImageForDealerApp";
    const Endpoints = {
        GetStream: "GetStream",
        GetChannelSubChannelSegAndCustData: "GetChannelSubChannelSegAndCustData",
        ValidateProduct: "ValidateProduct",
        ValidateSegmentsList: "ValidateSegmentsList",
        ValidateCustomersList: "ValidateCustomersList",
        UploadFiles: "UploadFiles",
        SavingPromotionalBanner : "SavingPromotionalBanner",
    }
    const BLOBDir = "OrderBannerUpload";
    const nav = useNavigate();

    const [preview, setPreview] = useState<string>(thumbnailUpload);
    const [fileBinary, setFileBinary] = useState<any>([]);
    const [fileSelected, setFileSelected] = useState(false);

    // Draft fields for the banner currently being prepared (before ADD is clicked)
    const [checked, setChecked] = useState<boolean>(false);
    const [SKUCode, setSKUCode] = useState<any>("");
    const [validProdLoading, setValidProdLoading] = useState<boolean>(false);
    const [validProdBool, setValidProdBool] = useState<boolean>(false);

    // Each added banner image now carries its own clickable flag + SKU code
    const [uploadedImages, setUploadedImages] = useState<{
        file: File;
        preview: string;
        checked: boolean;
        skuCode: string;
    }[]>([]);

    const currentDate = new Date();
    const date = subDays(new Date(), 7);
    const [fromdate, setFromdate] = useState<Date>(date);
    const [toDate, setToDate] = useState<Date>(currentDate);
    const [bannerName, setBannerName] = useState<any>("");
    const [stream, setStream] = useState<any>([]);
    const [selectedStream, setSelectedStream] = useState<any>([]);
   
    const [selectedTypeData, setSelectedTypeData] = useState<any>([]);
    const [typeData, setTypeData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [excelLoading, setExcelLoading] = useState<boolean>(false);
    const [validSegCustBool, setValidSegCustBool] = useState<boolean>(false);
    const [validSegLoading, setValidSegLoading] = useState<boolean>(false);
    const [radioBtnValue, setRadioBtnvalue] = useState<any>("CH");
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [excelData, setExcelData] = useState<any>([]);
    const [errorxlsbtn, setErrorxlsbtn] = useState(false);
    const [errorxlsData, setErrorxlsData] = useState([]);

    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const UserId = localStorage.getItem("UserId")?.toString();

    const handleClick = () => {
        inputRef.current?.click();
    };
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (file.type !== "image/png") {
            toast.warn("Invalid file type. Please upload a PNG image.");
            e.target.value = "";
            return;
        }

        const maxSize = 2 * 1024 * 1024;
        if (file.size > maxSize) {
            toast.warn("File size exceeds 2MB. Please upload a smaller image.");
            e.target.value = "";
            return;
        }

        const img = new Image();
        img.onload = () => {
            if (img.width > 412 || img.height > 158) {
                toast.warn('Image resolution cannot exceed Width : 412px, Height : 158px.');
                e.target.value = "";
                return;
            }

            setFileBinary(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result as string);
                setFileSelected(true);
            };
            reader.readAsDataURL(file);
        };

        img.src = URL.createObjectURL(file);
    };

    // CHANGED: also reset the draft's clickable + SKU fields
    const clearSelection = () => {
        setPreview(thumbnailUpload);
        setFileSelected(false);
        setFileBinary([]);
        setChecked(false);
        setSKUCode("");
        setValidProdBool(false);
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    };

   const handleValidateProd = async () => {
    const skuList = SKUCode
        .split(",")
        .map((s: string) => s.trim())
        .filter((s: string) => s.length > 0);

    if (skuList.length > 0) {
        setValidProdLoading(true);
        const payload = {
            tenantType: "CSD",
            validatE_PRODUCT: skuList.map((code: string) => ({
                proD_ID: code
            }))
        };
        try {
            const ValidateProductRes = await postData(
                Controller,
                `${Endpoints.ValidateProduct}`,
                payload
            );
            if (ValidateProductRes?.Status === "Error") {
                toast.error(`${ValidateProductRes?.Message}`);
                setValidProdBool(false);
            } else {
                toast.success(`${ValidateProductRes?.Message}`);
                setValidProdBool(true);
            }
        } catch (e: any) {
            console.log("Error", e);
            toast.error(`${e.response.data.Message}`);
        } finally {
            setValidProdLoading(false);
        }
    }
};
    const handleAddImage = () => {
    if (!fileSelected || !fileBinary) {
        toast.warn("Please select a banner image before adding.");
        return;
    }
    if (uploadedImages.length >= 3) {
        toast.warn("Maximum 3 banners are allowed.");
        return;
    }
    if (checked && !SKUCode) {
        toast.warn("SKU Code cannot be blank.");
        return;
    }
    if (SKUCode && !validProdBool) {
        toast.warn("Please validate the SKU Code.");
        return;
    }

    setUploadedImages(prev => [
        ...prev,
        {
            file: fileBinary,
            preview: preview,
            checked: checked,
            skuCode: SKUCode
        }
    ]);

    // reset the upload section (image + clickable + SKU) so the next banner can be added
    setPreview(thumbnailUpload);
    setFileSelected(false);
    setFileBinary([]);
    setChecked(false);
    setSKUCode("");
    setValidProdBool(false);
    if (inputRef.current) {
        inputRef.current.value = '';
    }
};

    const handleRemoveImage = (index: number) => {
        setUploadedImages(prev => prev.filter((_, i) => i !== index));
    };

    const PageLoad = async () => {
        setLoading(true);
        try {
            const GetStreamRes = await fetchData(
                Controller,
                `${Endpoints.GetStream}`,
                `TenantType=CSD`
            );
            setStream(GetStreamRes.Data);

        }
        catch (e) {
            console.log("Error", e);
        }
        finally {
            setLoading(false);
        }
    }

    const handleStreamChange = async (e: any) => {
        setSelectedStream(e);
        if (radioBtnValue === "CH" || radioBtnValue === "SC") {
            try {
                const GetChannelSubChannelSegAndCustDataRes = await fetchData(
                    Controller,
                    `${Endpoints.GetChannelSubChannelSegAndCustData}`,
                    `TenantType=CSD&STREAM_ID=${e?.STREAM_CODE}&TYPE_CODE=${radioBtnValue}`
                );
                setTypeData(GetChannelSubChannelSegAndCustDataRes.Data);
            }
            catch (e) {
                console.log("Error", e);
            }
            finally {
                setLoading(false);
            }
        }
    }
    const handleRadioBtnChange = async (e: any) => {
        setRadioBtnvalue(e);
        if (e === "CH" || e === "SC") {
            try {
                const GetChannelSubChannelSegAndCustDataRes = await fetchData(
                    Controller,
                    `${Endpoints.GetChannelSubChannelSegAndCustData}`,
                    `STREAM_ID=${selectedStream?.STREAM_CODE}&TYPE_CODE=${e}`
                );
                setTypeData(GetChannelSubChannelSegAndCustDataRes.Data);
                setSelectedTypeData([]);
            }
            catch (e) {
                console.log("Error", e);
            }
            finally {
                setLoading(false);
            }
        }
        else {
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            setExcelData([]);
            setValidSegCustBool(false);
            setErrorxlsbtn(false);
        }

    }

    const handleDownloadTemplate = async () => {
        if (selectedStream.length === 0) {
            toast.warn("Please select stream.")
        }
        else {
            setExcelLoading(true);
            try {
                const GetChannelSubChannelSegAndCustDataRes = await fetchData(
                    Controller,
                    `${Endpoints.GetChannelSubChannelSegAndCustData}`,
                    `TenantType=CSD&STREAM_ID=${selectedStream?.STREAM_CODE}&TYPE_CODE=${radioBtnValue}`
                );
                downloadExcelDateFormat(GetChannelSubChannelSegAndCustDataRes.Data, `${radioBtnValue === "SEG" ? `Segment_template_${GetDateFormat()}` : `Customer_Template_${GetDateFormat()}`}.xlsx`);
            }
            catch (e: any) {
                console.log("Error", e);
                toast.error(`${e.response.data.Message}`)
            }
            finally {
                setExcelLoading(false);
            }
        }

    }

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target?.result as ArrayBuffer);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData: any = XLSX.utils.sheet_to_json(worksheet);

            if (!jsonData || jsonData.length === 0) {
                toast.warn("The Excel file is empty.");
                return;
            }

            const expectedHeaders =
                radioBtnValue === "SEG"
                    ? ["SEG_CODE", "SEG_DESC"]
                    : ["COMP_ID", "CUST_CODE", "CUST_NAME"];

            const actualHeaders = Object.keys(jsonData[0]);

            const missingHeaders = expectedHeaders.filter(
                (header) => !actualHeaders.includes(header)
            );

            if (missingHeaders.length > 0) {
                toast.warn(
                    `Missing required columns: ${missingHeaders.join(", ")}`
                );
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
                return;
            }

            setExcelData(jsonData);
            console.log("ExcelData", jsonData)
        };

        reader.readAsArrayBuffer(file);
    };

    const handleValidateCustSeg = async () => {
        if (selectedStream.length === 0) {
            toast.warn("Please select stream.")
        }
        else if (excelData.length === 0) {
            toast.warn("Please choose a file.")
        }
        else {
            if (radioBtnValue === "SEG") {
                setValidSegLoading(true);
                const filteredSeg = excelData?.map((val: any) => ({
                    seG_CODE: val?.SEG_CODE,
                    seG_Name: val?.SEG_DESC
                }))
                const payload = {
                    tenantType: "CSD",
                    streaM_ID: selectedStream?.STREAM_CODE,
                    validatE_SEG_DATA: filteredSeg
                };
                try {
                    const ValidateSegmentsListRes = await postData(
                        Controller,
                        `${Endpoints.ValidateSegmentsList}`,
                        payload
                    );
                    if (ValidateSegmentsListRes?.Status === "Error") {
                        toast.warn("There are errors in validation.")
                        setErrorxlsbtn(true);
                        setErrorxlsData(ValidateSegmentsListRes.Data);
                        setValidSegCustBool(false);
                    }
                    else {
                        toast.success(`${ValidateSegmentsListRes?.Message}`);
                        setErrorxlsbtn(false);
                        setValidSegCustBool(true);
                    }
                }
                catch (e: any) {
                    console.log("Error", e);
                    toast.error(`${e.response.data.Message}`)
                }
                finally {
                    setValidSegLoading(false);
                }
            }
            else {
                setValidSegLoading(true);
                const filteredCust = excelData?.map((val: any) => ({
                    comP_ID: val?.COMP_ID,
                    cusT_CODE: val?.CUST_CODE,
                    cusT_ID: val?.CUST_ID,
                    cusT_NAME: val?.CUST_NAME
                }))
                const payload = {
                    tenantType: "CSD",
                    streaM_ID: selectedStream?.STREAM_CODE,
                    validatE_CUST_DATA: filteredCust
                };
                try {
                    const ValidateCustomersListRes = await postData(
                        Controller,
                        `${Endpoints.ValidateCustomersList}`,
                        payload
                    );
                    if (ValidateCustomersListRes?.Status === "Error") {
                        toast.warn("There are errors in validation.")
                        setErrorxlsbtn(true);
                        setErrorxlsData(ValidateCustomersListRes.Data);
                        setValidSegCustBool(false);
                    }
                    else {
                        toast.success(`${ValidateCustomersListRes?.Message}`);
                        setValidSegCustBool(true);
                    }
                }
                catch (e: any) {
                    console.log("Error", e);
                    toast.error(`${e.response.data.Message}`)
                }
                finally {
                    setValidSegLoading(false);
                }
            }
        }

    }

    const excelErrorDownload = () => {
        setLoading(true);
        downloadExcelDateFormat(errorxlsData, `Error_Segment_Validate_${GetDateFormat()}.xlsx`);
        setLoading(false);
    }

    // CHANGED: removed the global checked/SKU checks — those are now validated per-image in handleAddImage
    const validate = () => {
        if (!fromdate) {
            toast.warn("Start Date cannot be blank.")
            return false;
        }
        if (!toDate) {
            toast.warn("To Date cannot be blank.")
            return false;
        }
        if (selectedStream.length === 0) {
            toast.warn("Stream cannot be blank.")
            return false;
        }
        if (!bannerName) {
            toast.warn("Banner Name cannot be blank.")
            return false;
        }
        if (radioBtnValue === "CH" || radioBtnValue === "SC") {
            if (selectedTypeData.length === 0) {
                toast.warn(`${radioBtnValue === "CH" ? "Channel" : "Sub Channel"} cannot be blank.`)
                return false;
            }
        }
        if (radioBtnValue === "SEG" || radioBtnValue === "CUST") {
            if (fileInputRef.current?.value === "" || fileInputRef.current?.value === null) {
                toast.warn(`Please choose a ${radioBtnValue === "SEG" ? "Segment" : "Customer"} upload file.`)
                return false;
            }
            if (!validSegCustBool) {
                toast.warn(`Please validate the ${radioBtnValue === "SEG" ? "Segment" : "Customer"} file.`)
                return false;
            }
        }

        if (uploadedImages.length === 0) {
            toast.warn("Please add at least one banner image.")
            return false;
        }
        return true;
    }
const formatSkuList = (input: string): string => {
    return input
        .split(",")
        .map((s) => s.trim())
        .filter((s) => s.length > 0)
        .join("~");
};

   const handleSubmit = async () => {
    if (validate()) {
        setLoading(true);
        try {
            const formFile = new FormData();
            formFile.append('BLOBDir', `${BLOBDir}`);
            uploadedImages.forEach((img) => {
                formFile.append('FileContents', img.file);
            });

            const res = await AxiosExcel.post(`${ControllerImage}/${Endpoints.UploadFiles}`, formFile, {
                headers: { "Content-Type": "multipart/form-data" }
            });
           if (res?.data?.Status === "Success") {
    const uploadData = radioBtnValue === "CH" || radioBtnValue === "SC" ? 
    selectedTypeData?.map((val: any) => ({
        typE_ID : radioBtnValue,
        typE_VALUE : val?.CHANNEL_CODE
    }))
    : excelData?.map((val: any) => ({
        typE_ID : radioBtnValue,
        typE_VALUE : val?.SEG_CODE
    })); 
    const typeValue = radioBtnValue === "CH" || radioBtnValue === "SC" ? selectedTypeData?.map((val: any) => `${val?.CHANNEL_CODE}`).join(",") : excelData?.map((val: any) => `${val?.SEG_CODE}`).join(",");
    const mappedCust = radioBtnValue === "CUST" ? excelData?.map((val: any) => ({
        comP_ID: val?.COMP_ID,
        cusT_CODE: val?.CUST_CODE,
        cusT_NAME: val?.CUST_NAME
    })) : [];
    
    // CHANGED: response is now an array of { UploadedFileUri, FileName } objects,
    // extract just the UploadedFileUri for each, in the same order files were sent
    const bannerImgUrls: string[] = (res?.data?.Data || []).map(
        (item: any) => item?.UploadedFileUri
    );

    const uploadBannImgSku = uploadedImages.map((img, idx) => ({
        imG_URL: bannerImgUrls?.[idx] || "",
        iS_BNR_CLKBL: img.checked,
        skU_LIST: formatSkuList(img.skuCode) || ""
    }));

    const Payload = {
        tenantType: "CSD",
        banneR_NAME: bannerName,
        starT_DATE: format(fromdate,"dd/MM/yyyy") ,
        enD_DATE: format(toDate,"dd/MM/yyyy"),
        streaM_CODE: selectedStream?.STREAM_CODE,
        dealeR_TYPE: radioBtnValue,
        uploaD_TYPE_DATA: uploadData,
        uploaD_CUST_DATA: mappedCust,
        useR_ID: UserId,
        uploaD_BANN_IMG_SKU: uploadBannImgSku
    }
    console.log("Payload",Payload);
    try{
        const SavingPromotionalBannerRes = await postData(
            Controller,
            `${Endpoints.SavingPromotionalBanner}`,
            Payload
        );
        toast.success(`${SavingPromotionalBannerRes.Message}`);
        nav('/BannerUpload/CSD')
    }
    catch(e:any){
        toast.error(`${e.response.data.Message}`);
        console.log("Error",e);
    }
    finally{
        setLoading(false);
    }
}
        }
        catch (e:any) {
            toast.error(`${e.response.data.Message}`);
            console.log("Error",e);
        }
        finally {
            setLoading(false);
        }
    }
}

    useEffect(() => {
        PageLoad();
    }, [])

    if (loading) {
        return (
            <Loader />
        )
    }
    else {
        return (
          <>
            <main>
              <div className="col-12 mb-5">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <nav aria-label="breadcrumb" className="drop-in">
                      <ol className="breadcrumb mx-0">
                        <li className="breadcrumb-item" aria-current="page">
                          Banner Upload
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/BannerUpload/CSD">Tertiary Upload</Link>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          View
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="text-end">
                      <Link to="/BannerUpload/CSD">
                        <button
                          type="button"
                          className="btn anime-secondary-btn me-2"
                        >
                          <Fa.FaLongArrowAltLeft className="backIcon ms-2" />{" "}
                          Back to All Records
                        </button>
                      </Link>
                      <button
                        type="button"
                        title="Save"
                        className="btn anime-btn"
                        onClick={handleSubmit}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
                <section className="sales-box">
                  <form>
                    <div className="row">
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-2">
                        <label className="form-label">
                          Start Date <span className="mandatory">*</span>
                        </label>
                        <Calendar
                          showIcon
                          value={fromdate}
                          onChange={(e) => setFromdate(e.value as Date)}
                          dateFormat="dd/mm/yy"
                          minDate={new Date()}
                        />
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-2">
                        <label className="form-label">
                          End Date <span className="mandatory">*</span>
                        </label>
                        <Calendar
                          value={toDate}
                          onChange={(e) => setToDate(e.value as Date)}
                          showIcon
                          dateFormat="dd/mm/yy"
                          minDate={fromdate}
                        />
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-2">
                        <label className="form-label">
                          Stream <span className="mandatory">*</span>
                        </label>
                        <Dropdown
                          placeholder="Select a Stream"
                          value={selectedStream}
                          onChange={(e) => handleStreamChange(e.value)}
                          options={stream}
                          optionLabel="STREAM_DESC"
                        />
                      </div>
                      <div className="col-lg-4 col-md-8 col-sm-12 mb-2">
                        <label className="form-label">
                          Banner Name <span className="mandatory">*</span>
                        </label>
                        <InputText
                          placeholder="Enter Banner Name"
                          value={bannerName}
                          onChange={(e) => setBannerName(e.target.value)}
                        />
                      </div>
                      {/* REMOVED: Clickable Banner switch + SKU Code fields from here — moved into the upload section below */}
                    </div>
                  
                    <div className="border rounded p-3 mt-3">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <label className="form-label d-block mb-2">
                            Upload Type <span className="mandatory">*</span>
                          </label>
                          <div className="d-inline-flex">
                            <div className="flex align-items-center">
                              <RadioButton
                                inputId=""
                                name="Channel"
                                value="CH"
                                onChange={(e) => handleRadioBtnChange(e.value)}
                                checked={radioBtnValue === "CH"}
                              />
                              <label htmlFor="ingredient1" className="mx-2">
                                Channel
                              </label>
                            </div>
                            <div className="flex align-items-center">
                              <RadioButton
                                inputId=""
                                name="Sub Channel"
                                value="SC"
                                onChange={(e) => handleRadioBtnChange(e.value)}
                                checked={radioBtnValue === "SC"}
                              />
                              <label htmlFor="ingredient1" className="mx-2">
                                Sub Channel
                              </label>
                            </div>
                            <div className="flex align-items-center">
                              <RadioButton
                                inputId=""
                                name="Segment"
                                value="SEG"
                                onChange={(e) => handleRadioBtnChange(e.value)}
                                checked={radioBtnValue === "SEG"}
                              />
                              <label htmlFor="ingredient1" className="mx-2">
                                Segment
                              </label>
                            </div>
                            <div className="flex align-items-center">
                              <RadioButton
                                inputId=""
                                name="Customer"
                                value="CUST"
                                onChange={(e) => handleRadioBtnChange(e.value)}
                                checked={radioBtnValue === "CUST"}
                              />
                              <label htmlFor="ingredient1" className="mx-2">
                                Customer
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          {(radioBtnValue === "CH" ||
                            radioBtnValue === "SC") && (
                            <div className="d-block">
                              <label className="form-label">
                                {radioBtnValue === "CH"
                                  ? "Channel"
                                  : "Sub Channel"}{" "}
                                <span className="mandatory">*</span>
                              </label>
                              <MultiSelect
                                value={selectedTypeData}
                                onChange={(e) => setSelectedTypeData(e.value)}
                                options={typeData}
                                selectAllLabel="All"
                                optionLabel="CHANNEL_DES"
                              />
                            </div>
                          )}
                        </div>

                        {(radioBtnValue === "SEG" ||
                          radioBtnValue === "CUST") && (
                          <div className="d-block col-12 mt-3">
                            <div className="d-inline-block">
                              <button
                                type="button"
                                className="anime-btn me-3"
                                onClick={handleDownloadTemplate}
                              >
                                {excelLoading
                                  ? "Loading..."
                                  : "Download Template"}{" "}
                                {excelLoading ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                ) : (
                                  <Fa.FaDownload className="ms-2" />
                                )}
                              </button>
                            </div>

                            <div className="d-inline-block uploadInput">
                              <label className="form-label d-block ms-3">
                                Upload File <span className="mandatory">*</span>
                              </label>
                              <input
                                ref={fileInputRef}
                                type="file"
                                className="file-upload ms-3"
                                onChange={handleFileUpload}
                              />
                              <button
                                type="button"
                                title="Validate"
                                className="btn anime-secondary-btn me-3"
                                onClick={handleValidateCustSeg}
                              >
                                {validSegLoading ? "Validating..." : "Validate"}{" "}
                                {validSegLoading ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                ) : (
                                  ""
                                )}
                              </button>
                            </div>

                            <div className="d-inline-block">
                              {errorxlsbtn && (
                                <button
                                  type="button"
                                  title="Validate"
                                  className="btn anime-red-btn ms-3"
                                  onClick={excelErrorDownload}
                                >
                                  Error Download
                                </button>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <section className="border rounded p-3 mt-3 DealerAppBannerUploadPanel">
                      <div className="card mb-3">
                        <div className="row d-flex align-items-center justify-content-center">
                          <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">
                              Clickable Banner
                            </label>
                            <InputSwitch
                              className="switch-pos ms-2"
                              checked={checked}
                              onChange={(e) => setChecked(e.value)}
                            />
                          </div>
                          {checked && (
                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                              <label className="form-label">
                                SKU Code<span className="mandatory">*</span>
                              </label>
                              <div
                                className="input-group"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <InputText
                                  className="form-control"
                                  type="text"
                                  placeholder="Enter SKU Code(s), separated by comma"
                                  value={SKUCode}
                                  onChange={(e) => setSKUCode(e.target.value)}
                                />
                                <div className="input-group-prepend">
                                  <span
                                    className="input-group-text ms-2 p-2"
                                    onClick={handleValidateProd}
                                  >
                                    {validProdLoading
                                      ? "Validating..."
                                      : "Validate"}{" "}
                                    {validProdLoading ? (
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="col-lg-2 col-md-2 col-sm-12">
                           
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="col-12">
                          <form>
                            <h6>
                              Banner Upload <span className="mandatory">*</span>
                            </h6>
                            <input
                              type="file"
                              className="file-upload d-none"
                              ref={inputRef}
                              onChange={handleFileChange}
                            />
                            <img
                              src={preview}
                              className="UploadImg"
                              onClick={handleClick}
                            />
                            {fileSelected && (
                              <button
                                onClick={clearSelection}
                                aria-label="Clear selected image"
                                title="Remove"
                                className="cross"
                              >
                                ×
                              </button>
                            )}
                            <p>
                              Click here to upload image
                              <br></br>
                              Kindly keep the resolution to "Width: 412, Height:
                              158, File Type: PNG" for best view
                            </p>

                            {/* NEW: Clickable Banner + SKU Code now apply to the banner currently being added */}

                            <button
                              type="button"
                              title="Add"
                              className="btn anime-btn mt-2"
                              onClick={handleAddImage}
                              disabled={!fileSelected}
                            >
                              <Fa.FaPlus className="me-2" />
                              ADD
                            </button>
                          </form>
                        </div>

                        {/* List of added banner images, each showing its own clickable/SKU info */}
                        {uploadedImages.length > 0 && (
                          <div className="d-flex flex-wrap mt-3">
                            {uploadedImages.map((img, index) => (
                              <div key={index} className="bannerUPloadPreview">
                                <img
                                  src={img.preview}
                                  className="UploadImg"
                                  alt={`Banner ${index + 1}`}
                                />
                                <button
                                  type="button"
                                  onClick={() => handleRemoveImage(index)}
                                  aria-label="Remove image"
                                  title="Remove"
                                  className="cross"
                                >
                                  ×
                                </button>
                                <div className="small mt-1">
                                  {img.checked ? "Clickable" : "Not Clickable"}
                                  {img.skuCode ? ` • SKU: ${img.skuCode}` : ""}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </section>
                  </form>
                </section>
              </div>
            </main>
          </>
        );
    }
}

export default BannerUploadCSDView